module.exports = __webpack_public_path__ + "static/media/Shopify_logo_2018.120eacb0.svg";